export const clusterByLatLng = objects => {
  return objects.reduce((aggregate, object) => {
    const coords = [object.latitude, object.longitude];
    if (!aggregate[coords]) { aggregate[coords] = []; }
    aggregate[coords].push(object);
    return aggregate;
  }, {});
};
